<script setup lang="ts">
import { numFixedUnit } from '@gto/helpers/number-formatting'
import { i18n } from '@/locales/i18n'

import GwSiteItem from '@/components/DataTables/Filters/new/items/GwSiteItem.vue'
import GwStatusItem, { type StatusItemT } from '@/components/lib/GwTable/GwStatusItem.vue'
import GwColorItem from '@/components/DataTables/Filters/new/items/GwColorItem.vue'

interface GwFilterBtnsItemProps {
  field: Record<string, any>
  item: string
  tstPrefix?: string
}

const props = withDefaults(defineProps<GwFilterBtnsItemProps>(), {
  tstPrefix: 'item',
})

const {
  global: { t },
} = i18n

const getName = ({ field, item }: { field: Record<string, any>; item: any }) => {
  const name = item[field.display_key] || item
  const conf: Record<string, () => any> = {
    blinds: () =>
      `${item.currency}/${item.small_blind}/${item.big_blind}/${item.ante}/${item.straddle}`,
    big_blind: () => numFixedUnit(Number(name), 'bb'),
    game_format: () => t(`gametypes.groups.${name.toLowerCase()}`),
    gameformat: () => t(`gametypes.groups.${name.toLowerCase()}`),
    position: () => t(`players.${name}`),
    hero: () => t(`players.${name}`),
    villain: () => t(`players.${name}`),
    street: () => t(`common.${name.toLowerCase()}`),
    l_gmf_format: () => t(`gametypes.groups.${name.toLowerCase()}`),
    spot_type: () => t(`shortcut.${name}`),
    drill_type: () => t(`common.${name.toLowerCase()}`),
  }
  return (conf[field.field_name] || (() => item[field.display_key] || item))()
}
</script>
<template>
  <GwSiteItem
    v-if="props.field.field_name === 'site'"
    :siteId="item"
    :tstPrefix="tstPrefix"
  />
  <GwStatusItem
    v-else-if="props.field.field_name === 'status'"
    :value="item as StatusItemT"
    :tstPrefix="tstPrefix"
  />
  <GwColorItem
    v-else-if="props.field.picker === 'GwColorPicker'"
    :item="item"
    :tstPrefix="tstPrefix"
  />
  <div
    v-else
    class="truncate line-height_initial"
    :data-tst="`${props.tstPrefix}_item_${item[props.field.display_key] || item}`"
  >
    {{ getName({ field, item }) }}
  </div>
</template>
